<div class="bar" [class.pass]="score >= 1"></div>
<div class="bar" [class.pass]="score >= 2"></div>
<div class="bar" [class.pass]="score >= 3"></div>
<div class="bar" [class.pass]="score >= 4"></div>

<div class="wording">
  {{ wording }}
</div>

